import { render, staticRenderFns } from "./FileMetadata.vue?vue&type=template&id=0db72259"
import script from "./FileMetadata.vue?vue&type=script&lang=ts"
export * from "./FileMetadata.vue?vue&type=script&lang=ts"
import style0 from "./FileMetadata.vue?vue&type=style&index=0&id=0db72259&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports